export default "__VITE_ASSET__e5051812__"